import { render, staticRenderFns } from "./EgiftThanks.vue?vue&type=template&id=26e72093&"
import script from "./EgiftThanks.vue?vue&type=script&lang=js&"
export * from "./EgiftThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports